import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button } from '../../../../../Common/Button'

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  padding: 0 24px 24px;
  position: relative;
`

export const PasteWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

export const ButtonIcon = styled(FontAwesomeIcon)`
  color: #005cd9;
  display: block;
  font-size: 1rem;
  left: 1%;
  margin: 9px;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
`

export const AbsoluteIcon = styled(ButtonIcon)`
  position: absolute;
  top: calc(50% - 1rem);
`

const ExtendedButtonBase = styled(Button)`
  background-color: rgba(0, 92, 217, 0.14);
  border: none;
  margin-left: 8px;

  &:hover {
    background: rgba(0, 92, 217, 0.2)
      radial-gradient(circle, transparent 1%, rgba(0, 92, 217, 0.2) 1%)
      center/15000%;
  }

  &:active {
    background-color: rgba(0, 92, 217, 0.3);
  }

  &:focus {
    background-color: rgba(0, 92, 217, 0.3);
    border-bottom: 2px solid #005cd9;
  }
`

export const CopyButton = styled(ExtendedButtonBase)``

export const CutButton = styled(ExtendedButtonBase)``

export const CheckoutButton = styled(ExtendedButtonBase)`
  position: relative;
`

export const NoShowButton = styled(ExtendedButtonBase)`
  position: relative;
`

export const BtnText = styled.span`
  color: #005cd9;
  font-weight: 700;
`
